import _axios from '@/assets/utils/_axios'
import axios from 'axios'
import { _confirm, _alert, _loading } from '../../assets/utils/utils'
import Router from '@/router'

//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;

export default {
  /*管理员创建门店*/
  async POST_Admin_AddStore({commit, getters},{data,type,successFun}) {
    let loading = _loading({target: '.blank_space'})
    let url = '';
    switch (type*1) {
        case 2:
        url = '/pc/Admin/AddTravelBase';
        data.travel_tel = data.store_tel;
        break;
        case 3:
        url = '/pc/Admin/AddHotelBase';
        data.hotel_tel = data.store_tel;
        break;
    };
    delete data.store_tel;
    let res = await _axios.post(url, {
        ...data
    })
    loading.close()
    if (res.code === '00000') successFun( res.data )
  },
  /*管理员创建企业账户*/
  async POST_Admin_CreateStoreUsername({commit, getters},{data,successFun}) {
    _confirm('确定创建该企业账号吗？',async () => {
      let loading = _loading({target: '.blank_space'})
      let res = await _axios.post('/pc/Admin/CreateStoreUsername', {
          ...data
      })
      loading.close()
      if (res.code === '00000') _alert('企业账号创建成功', successFun)
    })
  },
  /*管理员获取企业列表*/
  async POST_Admin_StoreList ({ commit, getters,dispatch }, {data,successFun}) {
    let url = '';
    switch (Number(data.storeType)) {
        case 2:
          url = '/pc/Admin/TravelList';
        break;
        case 3:
          url = '/pc/Admin/HotelList';
        break;
        case 4:
          url = '/pc/Admin/StoreList';
        break;
    };
    let res = await _axios.post(url, {
      num:NUM,
      ...data
    });
    if (res.code === '00000'){
      // 批量处理：遍历所有对象，统一转换
      res.data.list=res.data.list.map(item => {
        item.hotel_tel=item.hotel_tel|| '';
        return {
          ...item,
          hotel_tel: item.hotel_tel.trim().split(',').filter(Boolean) || []
        }
      });
      res.data.lists =res.data.list,
      res.data.total = res.data.count || 0;
      successFun(res.data)
    }
  },
  /* 管理员下载表单 */
  async POST_Admin_DownloadForm({ commit }, { data, type }) {
    try {
      // 1. 生成时间文件名
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const fileName = `${year}-${month}-${day} ${hours}_${minutes}_${seconds}`;

      // 2. 接口映射
      const apiMap = {
        1: '/pc/Admin/PaymentPendingExport',    // 待付款
        2: '/pc/Admin/PaymentRecordExport',     // 已付款
        3: '/pc/Admin/TradeRecordExport',     // 系统收款
        4: '/pc/Admin/RefundRecordExport',     // 系统退款
      };
      const url = apiMap[type] || '';
      if (!url) throw new Error('下载类型错误');

      // 3. 请求文件
      const blob = await _axios({
        url,
        method: 'POST',
        data,
        responseType: 'blob',
      });

      // 4. 【关键】判断是否是文件Blob
      if (!(blob instanceof Blob)) {
        _alert('返回数据不是文件格式');
        return;
      }

      // 5. 下载
      const fileTitle = type == 1 ? '待付款' : type == 2 ? '退款' : type == 3 ? '系统收款' : '系统退款';
      const downloadName = `${fileTitle}_${fileName}.xlsx`;
      const downloadUrl = URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = downloadName;
      a.click();
      
      URL.revokeObjectURL(downloadUrl);
      _alert('文件下载成功');
      
    } catch (err) {
      console.error('下载异常：', err);
      _alert('下载失败，请稍后重试', null, 'error');
    }
  },
  /*管理员添加企业销售*/
  async POST_Admin_AddUser({commit, getters},{data,successFun}) {
    _confirm('确定添加该企业销售吗？',async () => {
      let res = await _axios.post('/pc/Admin/AddUser', {...data});
      if (res.code === '00000') _alert('添加企业销售成功',()=>{successFun(res.data)})
    })
  },
}
